import CoreApi from '@/api/CoreApi';
import type { Group } from '@/models/Group';
import type { GroupChildren } from '@/models/GroupChildren';
import type { UserInternal } from '@/models/User';

export async function loadCustomerUsersInternal(): Promise<UserInternal[]> {
  try {
    const response = await CoreApi.axiosClient.get('/internal/users');
    return response.data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error(error);
    throw new Error(`Failed to customer users: ${error.message}`);
  }
}

export async function loadRootGroupsInternal(
  userUuid: string,
): Promise<Group[]> {
  try {
    const response = await CoreApi.axiosClient.get(
      `/groups/root?user_uuid=${userUuid}`,
    );
    return response.data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error(error);
    throw new Error(`Failed to load groups: ${error.message}`);
  }
}

export async function loadGroupChildrenInternal(
  userUuid: string,
  groupUuid: string,
): Promise<GroupChildren> {
  try {
    const response = await CoreApi.axiosClient.get(
      `/groups/children/${groupUuid}?user_uuid=${userUuid}`,
    );
    return response.data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error(error);
    throw new Error(`Failed to load groups: ${error.message}`);
  }
}
